import type { RouteRecordRaw } from 'vue-router'
import { PERMISSIONS } from '@/core/permissions/constants'

export const menuRoutes: RouteRecordRaw[] = [
  {
    path: '/menus',
    name: 'menus',
    component: () => import('@/modules/menus/views/MenuListView.vue'),
    meta: {
      permission: PERMISSIONS.CONTENT.VIEW,
      projectScoped: true,
    },
  },
]
